import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import SelectField from '../../../../shared/form-elements/select/field';
import TextArea from  '../../../../shared/form-elements/textarea';
import RichTextField from  '../../../../shared/form-elements/rich-text';
import createConfirm from '../../../../shared/confirm';

const isRequired = value => (value ? undefined : 'Required');

const propTypes = {
	restrictedGeoFormData: PropTypes.object,
	fields: PropTypes.object,
	intl: PropTypes.func,
	restrictedGeolocationsLookups: PropTypes.func
};

const isEverad = process.env.CPA_ENV === 'everad';

const RenderFieldArray = props => (
	<div className="fields-wrap">

		<div className="fields-wrap__add" onClick={() => props.fields.push({})}>
			<span className="fields-wrap__add-title">{props.intl('Add restricted geo')}</span>
		</div>

		<div className="fields-wrap__list">
			{ props.fields.map((parentName, index, fields) => {
				const field = props.fields.get(index);
				return (
					<div className="fields-wrap__list-item" key={index}>
						<div className="fields-wrap__list-item--position-location">
							<Field name={`${parentName}.id`} component="input" type="hidden" />
							<Field
								name={`${parentName}.location`}
								placeholder={props.intl('Select geo')}
								component={SelectField}
								multi={false}
								showLabel={false}
								clearable={false}
								validate={[isRequired]}
								disabled={props.restrictedGeoFormData.isTranslateTab}
								options={props.restrictedGeolocationsLookups} />
						</div>

						<div className="fields-wrap__list-item--position-text">
							<Field
								name={`${parentName}.text`}
								placeholder={props.intl('Restricted geo')}
								component={isEverad ? RichTextField : TextArea }
								normalize={(value, oldValue) =>
									value.length >= 1500 ? oldValue: value
								}
								validate={[isRequired]}
								showLabel={false} />
						</div>

						{ !props.restrictedGeoFormData.isTranslateTab && (
							<div className="fields-wrap__list-item--position-remove">
								<span
									className="remove"
									onClick={() => {
										createConfirm({
											title: props.intl('Remove restricted'),
											body: props.intl('Are you sure you want to remove the geo constraint?'),
											buttonSuccessText: props.intl('Confirm'),
											buttonCancelText: props.intl('Cancel')
										}).then(isConfirmed => {
											if (isConfirmed) {
												field.id
													? props.restrictedGeoDelete(field.id)
													: props.fields.remove(index);
											}
										});
									}} />
							</div>
						) }

					</div>
				);
			}) }
		</div>

		{ props.fields.length > 0 && (
			<div className="fields-wrap__btn">
				<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
			</div>
		) }

	</div>
);

RenderFieldArray.propTypes = propTypes;

export default RenderFieldArray;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/restricted-geo/render-field-array.js